export const parkingNwStyles = {
	header: {
		backgroundColor: '#00a0e0',
	},
	sidebar: {
		backgroundColor: '#000000',
		color: 'white',
	},
	button: {
		backgroundColor: '#2fc936',
		border: '1px solid #239729',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#239729',
			border: '1px solid #239729',
		},
	},
	text: {
		color: '#000000',
		buttonLoadingColor: '#000000',
	},
	title: {
		color: '#ffffff',
	},
	table: {
		headerBackgroundColor: '#000000',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parking NW Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/parkingNw/pnw-icon-blue.png',
			height: 45,
			width: 36,
		},
		large: {
			src: '/parkingNw/pnw-logo-white.png',
			height: 48,
			width: 120,
		},
	},
	favicon: {
		src: '/parkingNw/pnw-icon-blue.png',
	},
	socials: {},
	siteUrl: 'https://parkingnw.com/',
	orgName: 'Parking NW',
};
